<template>
    <div class="static-markdown">
        <div v-html="sanitized"></div>
    </div>
</template>
<script>
import { marked } from 'marked';
import sanitizeHtml from 'sanitize-html';
export default {
    name: 'staticMarkdown',
    props: {
        content: {
            type: String,
            required: true
        }
    },
    computed: {
        sanitized() {
            try {
                return sanitizeHtml(marked(this.content));
            } catch (error) {
                return this.content;
            }
        }
    }
}
</script>

<style lang="scss">

.static-markdown {
    // font-size: 14px;
    // line-height: 1.5;
    // color: #333;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-top: 1.5em;
        margin-bottom: 0.5em;
    }

    p {
        margin-top: 0;
        margin-bottom: 1em;
    }

    pre {
        padding: 10px;
        border-radius: 4px;
        overflow-x: auto;
    }

    code {
        padding: 2px 4px;
        border-radius: 4px;
    }
}
</style>